import React, { useEffect, useState } from 'react'
import { portal } from '../portalApi.js'
import { fmt } from '../api.js'
import NoteDrawer from '../components/NoteDrawer.jsx'

// 매칭현황 — 전자결재에서 이체완료됐지만 은행 거래와 자동매칭되지 않은 지출 라인
export default function TreasuryMatch({ currentUserId, autoOpenNoteId, onAutoOpened }) {
  const [rows, setRows] = useState(null)
  const [err, setErr] = useState('')

  useEffect(() => {
    portal.get('/api/approval/unmatched-transfers')
      .then((r) => setRows(Array.isArray(r) ? r : []))
      .catch((e) => setErr(e.status === 403 ? '매칭현황 화면 권한이 없습니다.' : e.message))
  }, [])

  return (
    <>
      <div style={{ position: 'relative' }}>
        <h2>매칭현황 — 전자결재 미매칭 이체</h2>
        <NoteDrawer target="treasury-match" screenKey="treasury"
          context={null} contextLabel={null} onNavigate={() => {}}
          autoOpenNoteId={autoOpenNoteId} onAutoOpened={onAutoOpened}
          currentUserId={currentUserId} />
      </div>
      <div className="hint">
        전자결재에서 <b>이체완료</b> 처리됐지만 은행 거래와 자동매칭되지 않은 건입니다.
        계좌 화면에서 해당 거래의 적요·계정과목을 확인하고 정리하세요.
      </div>
      {err && <div className="error-box">{err}</div>}
      {!err && !rows && <div className="muted">불러오는 중…</div>}
      {!err && rows && (
        <div className="panel">
          <table>
            <thead>
              <tr>
                <th>문서번호</th><th className="l">제목</th><th className="l">거래처</th><th className="l">예금주</th>
                <th className="l">입금계좌</th><th className="l">은행</th><th>금액</th>
                <th className="l">출금계좌</th><th className="l">계정과목</th><th>이체일</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={10} className="c muted">미매칭 건이 없습니다 🎉</td></tr>}
              {rows.map((r) => (
                <tr key={r.line_id}>
                  <td className="c">{r.doc_num}</td>
                  <td className="l">{r.title}</td>
                  <td className="l">{r.vendor}</td>
                  <td className="l">{r.holder}</td>
                  <td className="l">{r.account}</td>
                  <td className="l">{r.bank}</td>
                  <td>{fmt(r.amount)}</td>
                  <td className="l">{r.out_account}</td>
                  <td className="l">{r.account_cat}</td>
                  <td className="c">{r.transfer_date}</td>
                </tr>
              ))}
              {rows.length > 0 && (
                <tr className="total">
                  <td className="l" colSpan={6}>합계 {fmt(rows.length)}건</td>
                  <td>{fmt(rows.reduce((s, r) => s + (Number(r.amount) || 0), 0))}</td>
                  <td colSpan={3} />
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}
